import { render } from "./Head.vue?vue&type=template&id=5af06e7c&scoped=true"
import script from "./Head.vue?vue&type=script&lang=js"
export * from "./Head.vue?vue&type=script&lang=js"

import "./Head.vue?vue&type=style&index=0&id=5af06e7c&scoped=true&lang=css"

import exportComponent from "/opt/qyxs/qinyan_pro/qinyan_pro_client/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af06e7c"]])

export default __exports__